"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSingleIngredientMutation = void 0;
const client_1 = require("@apollo/client");
exports.parseSingleIngredientMutation = client_1.gql `
  mutation ParseSingleIngredient($ingredient: String!) {
    parseSingleIngredient(ingredient: $ingredient) {
      __typename
      name
      unit
      amount
      keyword
    }
  }
`;
//# sourceMappingURL=ParseSingleIngredient.js.map